import { render, staticRenderFns } from "./LoanTransFilter.vue?vue&type=template&id=2bfeefbd"
import script from "./LoanTransFilter.vue?vue&type=script&lang=js"
export * from "./LoanTransFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports